import { Modal } from 'antd';
import { strings } from '../../../lang';
import { useLoadingGuard } from '../../../hooks/use-loading-guard';
import { DoNotCloseTag } from '../../common/donotclose-tag';

export interface NotReachedModalProps {
  open: boolean;
  onOk: () => Promise<void>;
  onCancel: () => void;
}

export const NotReachedModal = ({ open, onOk, onCancel }: NotReachedModalProps) => {
  const [isLoading, guard] = useLoadingGuard();

  const onOkPressed = () => guard(onOk);

  return (
    <Modal
      title={strings.modalTitleNotReached}
      centered
      closable={false}
      maskClosable={false}
      keyboard={false}
      open={open}
      onOk={onOkPressed}
      okText={strings.saveAndOpenNextCase}
      cancelText={strings.cancel}
      onCancel={onCancel}
      okButtonProps={{ disabled: isLoading, loading: isLoading }}
      cancelButtonProps={{ disabled: isLoading }}
    >
      <p>{strings.modalTextNotReached}</p>
      {isLoading && <DoNotCloseTag />}
    </Modal>
  );
};
